import { call } from 'file-loader'
import { TweenMax, Power2, TimelineLite } from 'gsap'
/**
 * 旨提供一些小方法
 */

export const showClass = needShow => Object.prototype.toString.call(needShow).slice(8, -1)

/*
	URLSearchParams
*/
export const obj2urlsp = function(obj) {
  let urlsp = new URLSearchParams()
  for (var k in obj) urlsp.append(k, obj[k])
  return urlsp
}

/*
	async-validator
	mExps是map对象,里面有个key值为true或false的代表required
	表达式和对应的message互为键值对
*/

export const descriptor = function(mExps, trigger) {
  return [
    {
      required: mExps.has(true), //直接找required是否是true
      message: mExps.get(true),
      trigger
    },
    {
      validator(rule, value, callback, source, options) {
        if (!mExps.has(true) && (value === undefined || value === '')) {
          callback()
          return
        }
        let test = true
        mExps.forEach((message, exp) => {
          //如果required的选项是false就跳过
          if (exp === false) {
          }
          let expClass = showClass(exp)
          //如果是必填选项
          if (exp === true && (value === '' || value === undefined)) {
            callback(new Error(mExps.get(true)))
            test = false
          }
          //剩余的正则判断或者是函数判断
          else if (expClass == 'RegExp' && !exp.test(value)) {
            callback(new Error(message))
            test = false
          } else if (expClass == 'Function' && !exp(value)) {
            callback(new Error(message))
            test = false
          } else {
          }
        })
        if (test == true) callback()
      }
    }
  ]
}

/*
	返回Date对象的年月日时分秒
*/
export const date = function(timestamp) {
  return {
    DATE: new Date(timestamp),
    YY: new Date(timestamp).getFullYear(),
    M: new Date(timestamp).getMonth() + 1,
    MM:
      new Date(timestamp).getMonth() + 1 > 9
        ? new Date(timestamp).getMonth() + 1
        : '0' + (new Date(timestamp).getMonth() + 1),
    D: new Date(timestamp).getDate(),
    DD:
      new Date(timestamp).getDate() > 9
        ? new Date(timestamp).getDate()
        : '0' + new Date(timestamp).getDate(),
    h: new Date(timestamp).getHours(),
    hh:
      new Date(timestamp).getHours() > 9
        ? new Date(timestamp).getHours()
        : '0' + new Date(timestamp).getHours(),
    m: new Date(timestamp).getMinutes(),
    mm:
      new Date(timestamp).getMinutes() > 9
        ? new Date(timestamp).getMinutes()
        : '0' + new Date(timestamp).getMinutes(),
    s: new Date(timestamp).getSeconds(),
    ss:
      new Date(timestamp).getSeconds() > 9
        ? new Date(timestamp).getSeconds()
        : '0' + new Date(timestamp).getSeconds(),
    ms: new Date(timestamp).getTime()
  }
}

function PrefixInteger(num, n) {
  return (Array(n).join(0) + num).slice(-n)
}
export const timeFn = function(dateBegin) {
  //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  var dateEnd = new Date() //获取当前时间
  var dateDiff = dateEnd.getTime() - dateBegin //时间差的毫秒数
  var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) //计算出相差天数
  var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  var hours = PrefixInteger(Math.floor(leave1 / (3600 * 1000)), 2) //计算出小时数
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  var minutes = PrefixInteger(Math.floor(leave2 / (60 * 1000)), 2) //计算相差分钟数
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
  var seconds = PrefixInteger(Math.round(leave3 / 1000), 2)

  var leave4 = leave3 % (60 * 1000) //计算分钟数后剩余的毫秒数
  var minseconds = Math.round(leave4 / 1000)
  var timeFn = { days: dayDiff, hours, minutes, seconds, minseconds }
  return timeFn
}
/**
 * 截取对象直接量的某些属性至新的对象里
 * https://segmentfault.com/q/1010000012715651
 */
export const pick = (obj, arr) =>
  arr.reduce((iter, val) => (val in obj && (iter[val] = obj[val]), iter), {})

export const countAnimate = function(config) {
  let { n, o, p, update, complete, duration = 2 } = config

  let that = this
  TweenMax.to(o, duration, {
    ...n,
    onUpdate: () => {
      for (var k in n) {
        let cur = that
        if (p) {
          p.split('.').forEach(pp => {
            cur = cur[pp]
          })
          cur[k] = o[k].toFixed(0) - 0
        } else {
          that[k] = o[k].toFixed(0) - 0
        }
      }
      update ? update() : null
    },
    onComplete: complete ? complete : () => {},
    ease: 'slow(0.7, 0.7, false)'
  })
}

//将得到的csv转为数组
export const csvToObject = csvString => {
  var csvarry = csvString.split('\r\n')
  var datas = []
  var headers = csvarry[0].split(',')
  for (var i = 1; i < csvarry.length; i++) {
    var data = {}
    var temp = csvarry[i].split(',')
    for (var j = 0; j < temp.length; j++) {
      data[headers[j]] = temp[j]
    }
    datas.push(data)
  }
  return datas
}

export const keyboard = class keyboard {
  constructor(needKeyCodes, callback, event = 'keydown') {
    this.event = event
    this.needKeyCodes = needKeyCodes
    this.callback = callback
    this.keyValue = new Map([[32, 'Space']])
    this.triggeredKeyCodes = new Set([])
    this.timestamp = 0
    this.removeEvent()
    this.addEvent()
  }
  fn(e) {
    //console.log(e);
    this.reset()
    this.triggeredKeyCodes.add(e.keyCode)
    if (this.needKeyCodes.every(key => this.triggeredKeyCodes.has(key))) {
      this.callback()
    } else {
      //console.log(this.needKeyCodes.map(keyCode => this.keyValue.get(keyCode)).join(',') + '没按完整')
    }
  }
  reset() {
    let timestamp = new Date().getTime()
    if (timestamp - this.timestamp > 1000) {
      this.triggeredKeyCodes = new Set([])
      this.timestamp = timestamp
    }
  }
  addEvent() {
    const that = this
    document.body.addEventListener(
      this.event,
      function(e) {
        e.preventDefault()
        that.fn(e)
      },
      false
    )
  }
  removeEvent() {
    const that = this
    document.body.removeEventListener(
      this.event,
      function(e) {
        that.fn(e)
      },
      false
    )
  }
}

export const dt = [
  {
    label: '手持终端',
    value: 1
  },
  {
    label: '车载终端',
    value: 2
  },
  {
    label: '固定终端',
    value: 3
  }
]

export const ws = [
  {
    label: '待指派',
    value: 0
  },
  {
    label: '已指派',
    value: 1
  },
  {
    label: '运行中',
    value: 2
  },
  {
    label: '已完成',
    value: 9
  }
]

export const yhdj = [
  {
    label: '一般隐患',
    value: 1
  },
  {
    label: '严重隐患',
    value: 2
  }
]
export const yhlx = [
  {
    label: '物的管理状态',
    value: 1
  },
  {
    label: '人的不安全行为',
    value: 2
  },
  {
    label: '管理缺陷',
    value: 3
  }
]

export const yhzt = [
  {
    label: '待审核',
    value: 0
  },
  {
    label: '上报待审核',
    value: 2
  },
  {
    label: '下派待审核',
    value: 3
  },
  {
    label: '驳回待派发',
    value: 4
  },
  {
    label: '待领取',
    value: 1
  },
  {
    label: '待验收',
    value: 6
  },
  {
    label: '处理中',
    value: 5
  },
  {
    label: '验收中',
    value: 7
  }
]

export const tzs = [
  {
    label: '警示提示通知书',
    value: 0
  },
  {
    label: '安全生产督办通知书',
    value: 1
  }
]

export const oxksd = [
  {
    label: '高危单位',
    value: 0
  },
  {
    label: '重点单位',
    value: 1
  },
  {
    label: '九小单位',
    value: 2
  },
  {
    label: '高层建筑',
    value: 3
  },
  {
    label: '一般单位',
    value: 4
  },
  {
    label: '出租房',
    value: 5
  }
]

export const lkgkijf = [
  {
    label: '消防检查',
    value: 0
  },
  {
    label: '火警',
    value: 1
  },
  {
    label: '巡检',
    value: 2
  }
]

export const klpasd = [
  {
    label: '室外消防栓',
    value: 0
  },
  {
    label: '微型消防站',
    value: 1
  }
]

export const getLatestYear = function(m, n) {
  let date = new Date()
  let startYear = date.getFullYear() - m //起始年份
  let endYear = date.getFullYear() + n
  let yearList = []
  for (var i = startYear; i <= endYear; i++) {
    let obj = {
      label: i,
      value: String(i)
    }
    yearList.push(obj)
  }
  return yearList
}

/**
 * @description 根据屏幕宽度计算字体大小 主要用来处理echarts字体大小
 */
export const getChartFontSize = function(res) {
  let clientWidth =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  if (!clientWidth) return 0
  let fontSize = clientWidth / 1920
  return res * fontSize
}
export const formatDate = function(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};



// WEBPACK FOOTER //
// ./src/utils/index.js